// extracted by mini-css-extract-plugin
export default {"cls1":"SocialActionsMenu-cls1_IMF","cls2":"SocialActionsMenu-cls2_jlo SocialActionsMenu-cls1_IMF"};